import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ProfileTab from "../../../core/common/profiletab";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const Communication = () => {
  const routes = all_routes;
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;

  const [isEditable, setIsEditable] = useState(false);
  const [isSameAddress, setIsSameAddress] = useState(false);
  const [communicationIds, setCommunicationIds] = useState({
    present_id: null,
    permanent_id: null,
  });
  const [data, setData] = useState({
    house_number: "",
    street_area: "",
    country: "",
    state: "",
    district: "",
    home_phone: "",
    office_phone: "",
    office_email: "",
    paramanent_house_number: "",
    paramanent_street_area: "",
    paramanent_country: "",
    paramanent_state: "",
    paramanent_district: "",
    paramanent_phone_number: "",
    paramanent_mobile_number: "",
    personal_email: "",
  });

  const getInputData = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSameAddressToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIsSameAddress(isChecked);

    setData((prev: any) => {
      if (isChecked) {
        return {
          ...prev,
          paramanent_house_number: prev.house_number || "",
          paramanent_street_area: prev.street_area || "",
          paramanent_country: prev.country || "",
          paramanent_state: prev.state || "",
          paramanent_district: prev.district || "",
          paramanent_phone_number: prev.home_phone || "",
          paramanent_mobile_number: prev.office_phone || "",
          personal_email: prev.office_email || "",
        };
      } else {
        return {
          ...prev,
          paramanent_house_number: "",
          paramanent_street_area: "",
          paramanent_country: "",
          paramanent_state: "",
          paramanent_district: "",
          paramanent_phone_number: "",
          paramanent_mobile_number: "",
          personal_email: "",
        };
      }
    });
  };

  const {
    data: cummunicationViewData,
    loading: cummunicationViewLoading,
    error: cummunicationViewError,
  } = useApi("/api/onboarding/view-communication", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (cummunicationViewData?.data) {
      const present = cummunicationViewData.data.find(
        (item: any) => item.address_type === "PRESENT"
      );
      const permanent = cummunicationViewData.data.find(
        (item: any) => item.address_type === "PERMANENT"
      );

      setData({
        house_number: present?.house_no || "",
        street_area: present?.street_area || "",
        country: present?.country || "",
        state: present?.state || "",
        district: present?.district || "",
        home_phone: present?.home_mobile || "",
        office_phone: present?.personal_mobile || "",
        office_email: present?.personal_email || "",
        paramanent_house_number: permanent?.house_no || "",
        paramanent_street_area: permanent?.street_area || "",
        paramanent_country: permanent?.country || "",
        paramanent_state: permanent?.state || "",
        paramanent_district: permanent?.district || "",
        paramanent_phone_number: permanent?.home_mobile || "",
        paramanent_mobile_number: permanent?.personal_mobile || "",
        personal_email: permanent?.personal_email || "",
      });
      setCommunicationIds({
        present_id: present?.ID || null,
        permanent_id: permanent?.ID || null,
      });
    }
  }, [cummunicationViewData]);

  const {
    data: cummunicationData,
    loading,
    error,
    callApi: postCommunicationData,
  } = useApi("/api/onboarding/add-communication", {
    method: "POST",
    autoCall: false,
  });

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const payload = {
      communication_data: [
        {
          house_no: data.house_number,
          street_area: data.street_area,
          country: data.country,
          state: data.state,
          district: data.district,
          home_mobile: data.home_phone,
          personal_mobile: data.office_phone,
          personal_email: data.office_email,
          address_type: "PRESENT",
        },
        {
          house_no: data.paramanent_house_number,
          street_area: data.paramanent_street_area,
          country: data.paramanent_country,
          state: data.paramanent_state,
          district: data.paramanent_district,
          home_mobile: data.paramanent_phone_number,
          personal_mobile: data.paramanent_mobile_number,
          personal_email: data.personal_email,
          address_type: "PERMANENT",
        },
      ],
    };

    try {
      const response = await postCommunicationData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data Update successfully!",
          confirmButtonColor: "#3085d6",
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: cummunicationEditData,
    loading: cummunicationEditLoading,
    error: cummunicationEditDataError,
    callApi: editCommunicationData,
  } = useApi("/api/onboarding/edit-communication", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    const payload = {
      communication_data: [
        {
          communication_id: communicationIds.present_id,
          house_no: data.house_number,
          street_area: data.street_area,
          country: data.country,
          state: data.state,
          district: data.district,
          home_mobile: data.home_phone,
          personal_mobile: data.office_phone,
          personal_email: data.office_email,
          address_type: "PRESENT",
        },
        {
          communication_id: communicationIds.permanent_id,
          house_no: data.paramanent_house_number,
          street_area: data.paramanent_street_area,
          country: data.paramanent_country,
          state: data.paramanent_state,
          district: data.paramanent_district,
          home_mobile: data.paramanent_phone_number,
          personal_mobile: data.paramanent_mobile_number,
          personal_email: data.personal_email,
          address_type: "PERMANENT",
        },
      ],
    };
    try {
      const response = await editCommunicationData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data Update successfully!",
          confirmButtonColor: "#3085d6",
        });
        setIsEditable(false);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };
  return (
    <div>
      <>
        {/* Page Wrapper */}

        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Profile</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Profile
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div
                  className="stickybar"
                  style={{ position: "sticky", top: "50px" }}
                >
                  <ProfileTab />
                </div>
              </div>

              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom mb-3 pb-3">
                      <h4>Communication</h4>
                    </div>
                    <form>
                      {/* Present Address Section */}
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Present</h6>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  House No / Floor <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  name="house_number"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.house_number}
                                  className="form-control"
                                  placeholder="Enter House No"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Street/Area
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Street/Area"
                                  name="street_area"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.street_area}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Country<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Country"
                                  name="country"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.country}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  State<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter State"
                                  name="state"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.state}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  District<sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter District"
                                  name="district"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.district}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Home Phone
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter Home Phone"
                                  name="home_phone"
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.home_phone}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Official Mobile
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter Official Mobile"
                                  name="office_phone"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={data.office_phone}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Official Email
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter Official Email"
                                  name="office_email"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.office_email}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" form-check mb-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="sameAddressCheckbox"
                          onChange={handleSameAddressToggle}
                        // disabled={!isEditable}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="sameAddressCheckbox"
                        >
                          Present and Permanent address are same
                        </label>
                      </div>

                      {/* Permanent Address Section */}
                      <div className=" border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Permanent</h6>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  House No / Floor <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  name="paramanent_house_number"
                                  value={data.paramanent_house_number}
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  className="form-control"
                                  placeholder="Enter House No"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Street/Area <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Street/Area"
                                  name="paramanent_street_area"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.paramanent_street_area}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Country <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Country"
                                  name="paramanent_country"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.paramanent_country}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  State <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter State"
                                  name="paramanent_state"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.paramanent_state}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  District <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter District"
                                  name="paramanent_district"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.paramanent_district}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Phone
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter Phone"
                                  name="paramanent_phone_number"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={data.paramanent_phone_number}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Personal Mobile
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="tel"
                                  className="form-control"
                                  placeholder="Enter Personal Mobile"
                                  name="paramanent_mobile_number"
                                  maxLength={10}
                                  pattern="\d*"
                                  inputMode="numeric"
                                  onKeyPress={(e) => {
                                    if (!/^\d$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.paramanent_mobile_number}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row align-items-center mb-3">
                              <div className="col-md-4">
                                <label className="form-label mb-md-0">
                                  Personal Email
                                </label>
                              </div>
                              <div className="col-md-8">
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter Personal Email"
                                  name="personal_email"
                                  onChange={getInputData}
                                  readOnly={
                                    communicationIds.present_id ||
                                      communicationIds.permanent_id
                                      ? !isEditable
                                      : false
                                  }
                                  value={data.personal_email}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}

                      <div className="d-flex align-items-center justify-content-end">
                        {communicationIds.permanent_id && communicationIds.present_id ? (
                          isEditable ? (
                            <>
                              <button
                                type="button"
                                className="btn btn-outline-light border w-25"
                                onClick={(e: any) => {
                                  e.preventDefault();
                                  setIsEditable(false);
                                }}
                              >
                                Cancel
                              </button>
                              &nbsp;
                              <button
                                type="submit"
                                className="btn btn-primary custom_button w-25"
                                onClick={handleEdit}
                              >
                                Update
                              </button>
                            </>
                          ) : (
                            // Apply canEdit logic here
                            (() => {
                              const canEdit =
                                status === "In Progress" ||
                                status === "Rejected" ||
                                status === "Re Open" ||
                                status === "Not Started";

                              return (
                                <button
                                  className="btn btn-primary custom_button w-25"
                                  onClick={(e: any) => {
                                    e.preventDefault();
                                    if (canEdit) setIsEditable(true);
                                  }}
                                  disabled={!canEdit}
                                  title={
                                    canEdit
                                      ? "Edit"
                                      : "Editing is disabled for this status"
                                  }
                                  style={{
                                    cursor: canEdit ? "pointer" : "not-allowed",
                                    opacity: canEdit ? 1 : 0.6,
                                  }}
                                >
                                  Edit
                                </button>
                              );
                            })()
                          )
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary custom_button w-25"
                            onClick={handleSubmit}
                          >
                            Save
                          </button>
                        )}
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default Communication;
